import axios from 'axios';

const API = '/api';

// Branches
export const getBranches = () => axios.get(`${API}/branches`);
export const createBranch = (data) => axios.post(`${API}/branches`, data);
export const updateBranch = (id, data) => axios.put(`${API}/branches/${id}`, data);
export const deleteBranch = (id) => axios.delete(`${API}/branches/${id}`);

// Departments
export const getDepartments = () => axios.get(`${API}/departments`);
export const getDepartmentsByBranch = (branchId) => axios.get(`${API}/departments/branch/${branchId}`);
export const createDepartment = (data) => axios.post(`${API}/departments`, data);
export const updateDepartment = (id, data) => axios.put(`${API}/departments/${id}`, data);
export const deleteDepartment = (id) => axios.delete(`${API}/departments/${id}`);

// Doctors
export const getDoctors = () => axios.get(`${API}/doctors`);
export const createDoctor = (data) => axios.post(`${API}/doctors`, data);
export const updateDoctor = (id, data) => axios.put(`${API}/doctors/${id}`, data);
export const deleteDoctor = (id) => axios.delete(`${API}/doctors/${id}`);

// Patients
export const getAllPatients = () => axios.get(`${API}/patients`);
export const getPatientById = (id) => axios.get(`${API}/patients/${id}`);
export const getPatientByPhone = (phone) => axios.get(`${API}/patients/phone/${phone}`);
export const registerPatient = (data) => axios.post(`${API}/patients`, data);

// Appointments
export const getAllAppointments = () => axios.get(`${API}/appointments`);
export const getAppointmentsByPatient = (patientId) => axios.get(`${API}/appointments/patient/${patientId}`);
export const bookAppointment = (data) => axios.post(`${API}/appointments`, data);
export const cancelAppointment = (id) => axios.put(`${API}/appointments/${id}/cancel`);
export const rescheduleAppointment = (id, data) => axios.put(`${API}/appointments/${id}/reschedule`, data);
export const completeAppointment = (id) => axios.put(`${API}/appointments/${id}/complete`);

// Slots
export const getSlots = (doctorId) => axios.get(`${API}/slots/doctor/${doctorId}`);
export const getAllSlotsByDate = (doctorId, date) => axios.get(`${API}/slots/doctor/${doctorId}/date/${date}/all`);
export const getAvailableSlots = (doctorId, date) => axios.get(`${API}/slots/doctor/${doctorId}/date/${date}`);
export const createSlot = (data) => axios.post(`${API}/slots`, data);

// Medical Records
export const getMedicalRecordByAppointment = (appointmentId) => axios.get(`${API}/medical-records/appointment/${appointmentId}`);
export const createMedicalRecord = (data) => axios.post(`${API}/medical-records`, data);
export const updateMedicalRecord = (id, data) => axios.put(`${API}/medical-records/${id}`, data);

// Reports
export const getReportsByPatient = (patientId) => axios.get(`${API}/reports/patient/${patientId}`);
export const uploadReport = (formData) => axios.post(`${API}/reports/upload`, formData);
export const deleteReport = (id) => axios.delete(`${API}/reports/${id}`);
export const downloadReport = (id) => axios.get(`${API}/reports/download/${id}`, { responseType: 'blob' });

export const noShowAppointment = (id) => axios.put(`${API}/appointments/${id}/no-show`);

// CORRECT
export const uploadDoctorPhoto = (id, formData) =>
  axios.post(`${API}/doctors/${id}/photo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteDoctorPhoto = (id) => axios.delete(`${API}/doctors/${id}/photo`);


